import { render, staticRenderFns } from "./viewProgramaModules.vue?vue&type=template&id=77a32516&scoped=true"
import script from "./viewProgramaModules.vue?vue&type=script&lang=js"
export * from "./viewProgramaModules.vue?vue&type=script&lang=js"
import style0 from "./viewProgramaModules.vue?vue&type=style&index=0&id=77a32516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a32516",
  null
  
)

export default component.exports